module.exports = __webpack_public_path__ + "static/media/Shoes.6d7cac3e.jpg";